import { StructuredText, Image } from 'react-datocms';
import { ReferralTypeFragment } from '@/utils/dato/generated';
import { isEmptyDocument, Document } from 'datocms-structured-text-utils';
import { customNodeRules, renderBlock } from '@/components/structuredText';

const ReferralType = ({ secondaryContent, primaryContent, image }: ReferralTypeFragment) => (
  <div className="max-w-[540px] md:max-w-[720px] lg:max-w-[960px] xl:max-w-[1224px] px-5 mx-auto pt-6 lg:pt-8">
    <div className="clearfix">
      <div className="display-heading clearfix -mx-4">
        <div className="[&_img]:max-md:object-cover px-4 h-auto max-md:rounded-xl [&>div]:max-md:h-full max-md:overflow-hidden max-lg:max-w-[430px] lg:w-[45%] mx-auto max-lg:mb-6 relative z-[4] lg:float-right">
          <Image data={image?.responsiveImage} className="mx-auto!" priority />
        </div>
        <div className="lg:w-[55%] lg:float-left px-4 mb-6 xl:mb-0">
          <StructuredText
            data={{ value: primaryContent?.value as Document, blocks: primaryContent?.blocks }}
            customNodeRules={customNodeRules}
            renderBlock={renderBlock}
          />
        </div>

        {!isEmptyDocument(secondaryContent?.value) ? (
          <div className="lg:float-left lg: w-full lg:relative lg:-mt-6" id="secondary-product-hero">
            <div className="relative pt-10 pb-4 px-5 z-[2] after:content-[''] after:absolute after:left-[-999px] after:w-[9999px] after:top-0 after:bottom-0 after:z-[-1] lg:after:w-[1000px] lg:after:left-[-40px] lg:after:bottom-0 lg:after:right-auto lg:after:rounded-lg xl:after:w-[1264px]">
              <div className="lg:flex lg:justify-between lg:items-center">
                <div className="lg:w-[41%]">
                  <StructuredText
                    data={{
                      value: secondaryContent?.value as Document,
                      blocks: secondaryContent?.blocks,
                    }}
                    customNodeRules={customNodeRules}
                    renderBlock={renderBlock}
                  />
                </div>
              </div>
            </div>
          </div>
        ) : null}
      </div>
    </div>
  </div>
);

export default ReferralType;
